import { defineStore } from 'pinia'
import { Pages } from '#shared/types/Pages'

// Public-site UI state. CMS state (buckets, locales, config) lives in the CMS layer's `main` store.
export const useSiteStore = defineStore('site', {
    state: () => ({
        header_icon_color: 'dark' as 'dark' | 'light',
        current_page: Pages.HOME,
    }),
    actions: {
        setIconColor(color: 'light' | 'dark') {
            this.header_icon_color = color
        },
        setCurrentPage(page: Pages) {
            this.current_page = page
        },
    },
})
